import { render, staticRenderFns } from "./StateBrowserUsermenu.vue?vue&type=template&id=0280de1a&"
import script from "./StateBrowserUsermenu.vue?vue&type=script&lang=js&"
export * from "./StateBrowserUsermenu.vue?vue&type=script&lang=js&"
import style0 from "./StateBrowserUsermenu.vue?vue&type=style&index=0&id=0280de1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports